import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumns20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTextColumns20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 5.75A.75.75 0 0 1 3.75 5H8a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5.75m0 5.997A.75.75 0 0 1 3.753 11l4.25.016a.75.75 0 0 1-.006 1.5l-4.25-.016A.75.75 0 0 1 3 11.747M3.75 8a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM3 14.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m8.25-9A.75.75 0 0 1 12 5h4.25a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75m0 5.998a.75.75 0 0 1 .752-.748l4.25.014a.75.75 0 0 1-.005 1.5l-4.25-.014a.75.75 0 0 1-.747-.752M12 8a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm-.75 6.75A.75.75 0 0 1 12 14h2.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumns20);
